/**
 * Returns the number of offers by domain, grouped by month,
 * formatted for the Nivo library.
 *
 * @param {OfferDomainCount[]} offersByDomain
 * @returns {NivoBarChartData} data formatted for a Nivo bar chart
 * @see {@link OfferDomainCount}
 */
export const getOffersByDomainsByPeriodData = (offersByDomain) => {
  /** @type {NivoBarChartData} */
  const chartData = [];

  offersByDomain.forEach((domain) => {
    let dataObject = {
      id: domain.label,
      label: domain.label,
      value: domain.total,
    };
    chartData.push(dataObject);
  });

  //? on tri par ordre croissant (date sous forme de string)
  chartData.sort((a, b) => {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  });

  return chartData;
};
